/* eslint-disable react/no-string-refs */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { Row, Col, Alert, Button } from 'react-bootstrap';
import { findIndex as _findIndex } from 'lodash';

import { getDescriptionInCurrentLanguage } from 'helpers/intl';
import {
  AUTOMOTIVE_SALES_PLUGIN,
  AUTOMOTIVE_RENT_PLUGIN,
  CHEDRI_COMMS_CENTER_PLUGIN,
  CONNECTME_PLUGIN,
  CUSTOMER_RETENTION_PC_PLUGIN,
} from 'js/constants';

import FormSwitchery from 'components/forms/FormSwitchery';
import RichEditorContent from 'components/RichEditorContent';

class PluginItem extends PureComponent {
  componentDidMount() {
    const { setComponent } = this.props;

    if (setComponent) {
      setComponent(this);
    }
  }

  componentWillUnmount() {
    const { setComponent } = this.props;

    if (setComponent) {
      setComponent(undefined);
    }
  }

  setValue = val => {
    const { plugin } = this.props;

    this.refs['sw1' + plugin.id].setValue(val);
    this.refs['sw2' + plugin.id].setValue(val);
  };

  hasSettings = pluginId => {
    const pluginsWithSettings = [
      AUTOMOTIVE_SALES_PLUGIN,
      AUTOMOTIVE_RENT_PLUGIN,
      CHEDRI_COMMS_CENTER_PLUGIN,
      CONNECTME_PLUGIN,
      CUSTOMER_RETENTION_PC_PLUGIN,
    ];
    return pluginsWithSettings.indexOf(pluginId) > -1;
  };

  getPluginActionButtons = (plugin, pluginActive, activationPending, hasSepaAgreement) => {
    const {
      intl: { messages },
      isDependent,
      masterActive,
      appIntl,
      history,
      layout,
      whiteLabel,
      onPluginActivationChange,
      onShowDetails,
      onShowSettings,
    } = this.props;

    const block = layout.breakpointIndex > 1;
    let className = 'm-b-10 ';
    if (layout.breakpointIndex < 2) {
      className += 'm-r-10';
    }

    return (
      <React.Fragment>
        {pluginActive && (
          <Button
            bsStyle={hasSepaAgreement ? 'default' : 'danger'}
            block={block}
            className={className}
            onClick={() => history.push(appIntl.urlPrefix + 'account/settings/plugins/' + plugin.id + '/sepa')}
          >
            <i className="fal fa-exclamation-circle" />{' '}
            <span className="hidden-xs hidden-sm m-l-10">{messages.sepa_mandate}</span>
          </Button>
        )}

        <Button block={block} className={className} onClick={() => onShowDetails(plugin)}>
          <i className="fas fa-info-circle" /> <span className="hidden-xs hidden-sm m-l-10">{messages.more_infos}</span>
        </Button>

        {!pluginActive && !activationPending && !!whiteLabel && (!isDependent || masterActive) && (
          <Button block={block} className={className} onClick={() => onPluginActivationChange(plugin, true)}>
            <i className="fal fa-check-double" />{' '}
            <span className="hidden-xs hidden-sm m-l-10">{messages.activate_plugin}</span>
          </Button>
        )}

        {pluginActive && this.hasSettings(plugin.id) && (
          <Button block={block} className={className} onClick={() => onShowSettings(plugin)}>
            <i className="fas fa-cogs" /> <span className="hidden-xs hidden-sm m-l-10">{messages.settings}</span>
          </Button>
        )}
      </React.Fragment>
    );
  };

  displayDependentPlugin = plugin => {
    const {
      pluginActive: masterActive,
      whiteLabel,
      onPluginActivationChange,
      onShowDetails,
      onShowSettings,
    } = this.props;

    return (
      <PluginItemWithProps
        plugin={plugin}
        whiteLabel={whiteLabel}
        isDependent={true}
        masterActive={masterActive}
        onPluginActivationChange={onPluginActivationChange}
        onShowDetails={onShowDetails}
        onShowSettings={onShowSettings}
      />
    );
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      plugin,
      isDependent,
      masterActive,
      dependentPlugins,
      pluginActive,
      activationPending = false,
      terminationPending = false,
      hasSepaAgreement = true,
      onPluginActivationChange,
      whiteLabel,
      showCompact,
    } = this.props;

    const pluginActions = this.getPluginActionButtons(plugin, pluginActive, activationPending, hasSepaAgreement);
    const switcheryLabel = <span className="font-secondary no-margin text-uppercase">{plugin.name}</span>;

    return (
      <div className="panel b-rad-lg m-b-20">
        <div className={`bg-master-lightest menuclipper padding-20 ${showCompact ? 'hidden' : 'hidden-xs hidden-sm'}`}>
          <Row>
            <Col xs={4} md={4}>
              {!!whiteLabel && (!isDependent || masterActive) && (
                <FormSwitchery
                  name={plugin.id}
                  ref={'sw1' + plugin.id}
                  preventChangeOnClick
                  onClick={() => onPluginActivationChange(plugin, !pluginActive)}
                  checked={pluginActive}
                  value="true"
                  key={plugin.id + whiteLabel.id}
                  label={switcheryLabel}
                />
              )}
            </Col>
            <Col xs={8} md={4}>
              <div className="font-secondary no-margin">
                {messages.price_from} {getDescriptionInCurrentLanguage(plugin.price_short_info, appIntl)}
              </div>
            </Col>
            <Col xs={12} md={4}>
              {pluginActions}
            </Col>
          </Row>
        </div>
        <div className="panel-body">
          <Row>
            <Col xs={12}>
              <div className={`m-b-15 ${showCompact ? '' : 'hidden-md hidden-lg'}`}>
                {!!whiteLabel && (!isDependent || masterActive) && (
                  <FormSwitchery
                    name={plugin.id}
                    ref={'sw2' + plugin.id}
                    preventChangeOnClick
                    onClick={e => onPluginActivationChange(plugin, !pluginActive)}
                    checked={pluginActive}
                    value="true"
                    key={plugin.id + whiteLabel.id}
                    label={<span className="font-secondary no-margin text-uppercase">{plugin.name}</span>}
                  />
                )}

                <div className="p-t-15">{pluginActions}</div>
              </div>

              {activationPending && <Alert>{messages.activation_pending}</Alert>}

              {terminationPending && <Alert bsStyle="warning">{messages.termination_pending}</Alert>}

              <RichEditorContent
                content={'<div>' + (getDescriptionInCurrentLanguage(plugin.description, appIntl) || '') + '</div>'}
              />

              {!!dependentPlugins && !!dependentPlugins.length && (
                <div className="m-t-20 p-t-20 b-t b-grey p-l-30 sm-p-l-15">
                  <h5 className="m-b-20">
                    <FormattedMessage
                      id="we_have_more_plugins_that_further_enhance_the_functionality"
                      values={{ plugin: <span className="semi-bold">{plugin.name}</span> }}
                    />
                  </h5>

                  {dependentPlugins.map((dependentPlugin, i) => {
                    return (
                      <div className={i > 0 ? 'b-t b-grey m-t-15 p-t-15' : ''} key={dependentPlugins.id}>
                        {this.displayDependentPlugin(dependentPlugin)}
                      </div>
                    );
                  })}
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
PluginItem.defautlProps = {
  plugin: null,
  isDependent: false,
  masterActive: false,
  dependentPlugins: [],
  pluginActive: false,
  activationPending: false,
  terminationPending: false,
  hasSepaAgreement: true,
  whiteLabel: null,
  showMobile: false,
  onPluginActivationChange: () => {},
  onShowDetails: () => {},
  onShowSettings: () => {},
  setComponent: () => {},
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    layout: state.layout,
  };
};

const PluginItemWithProps = withRouter(injectIntl(connect(mapStateToProps)(PluginItem)));
export default PluginItemWithProps;
